import { Link } from 'react-router-dom';

interface PortfolioProps {
  activeFilter: string;
  setActiveFilter: (filter: string) => void;
}

export default function Portfolio({ activeFilter, setActiveFilter }: PortfolioProps) {
  const filters = ['All', 'Web', 'Security', 'Social', 'Video'];

  const projects = [
    {
      id: 2,
      title: 'Dugo Law',
      category: 'Web',
      description: 'Professional law firm website',
      image: 'https://public.readdy.ai/ai/img_res/09b8ce8f1b81420e15438a6dee0b525b.jpg',
      caseStudy: '/portfolio/dugo-law',
      externalLink: 'https://www.dugolaw.com'
    },
    {
      id: 3,
      title: 'Glenn\'s Donuts',
      category: 'Web',
      description: 'Website design, development & photography',
      image: 'https://readdy.ai/api/search-image?query=Warm%20inviting%20donut%20shop%20website%20mockup%20on%20clean%20background%20showing%20colorful%20fresh%20donuts%20appetizing%20bakery%20design%20with%20warm%20amber%20and%20brown%20tones%20modern%20food%20business%20website%20clean%20typography%20cheerful%20branding%20professional%20web%20design%20aesthetic%20for%20local%20bakery&width=600&height=600&seq=portfolio-glenns-donuts-008&orientation=squarish',
      caseStudy: '/portfolio/glenns-donuts',
      externalLink: 'https://www.glennsdonuts.com'
    }
  ];

  const filteredProjects = activeFilter === 'All' 
    ? projects 
    : projects.filter(p => p.category === activeFilter);

  return (
    <section id="work" className="py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-16 gap-6">
          <div>
            <p className="text-sm font-medium text-[#1E3A8A] tracking-wide mb-4">
              OUR WORK
            </p>
            <h2 className="text-4xl md:text-5xl font-semibold text-neutral-900 tracking-tight">
              Our Portfolio
            </h2>
          </div>

          <div className="flex gap-2 bg-neutral-100 p-1 rounded-full">
            {filters.map((filter) => (
              <button
                key={filter}
                onClick={() => setActiveFilter(filter)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                  activeFilter === filter
                    ? 'bg-white text-neutral-900 shadow-sm'
                    : 'text-neutral-500 hover:text-neutral-700'
                }`}
              >
                {filter}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {filteredProjects.map((project) => (
            <div
              key={project.id}
              className="group relative overflow-hidden rounded-2xl cursor-pointer transition-all duration-500 hover:shadow-2xl hover:shadow-neutral-200/50"
            >
              <div className="relative w-full h-80">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-8 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                <span className="inline-block bg-white/90 text-[#1E3A8A] text-xs px-3 py-1 rounded-full font-medium">
                  {project.category}
                </span>
                <h3 className="text-2xl font-semibold text-white mt-2">
                  {project.title}
                </h3>
                <p className="text-sm text-white/80 mt-1">
                  {project.description}
                </p>
                {'caseStudy' in project && project.caseStudy ? (
                  <div className="flex items-center gap-4 mt-3">
                    <Link 
                      to={project.caseStudy}
                      className="inline-flex items-center gap-1 bg-white text-neutral-900 text-sm px-4 py-2 rounded-full font-medium hover:bg-neutral-100 transition-colors"
                      onClick={(e) => e.stopPropagation()}
                    >
                      View Case Study <i className="ri-arrow-right-line"></i>
                    </Link>
                    {'externalLink' in project && project.externalLink && (
                      <a 
                        href={project.externalLink} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1 text-white/90 text-sm hover:text-white transition-colors"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Visit Site <i className="ri-external-link-line"></i>
                      </a>
                    )}
                  </div>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
